import { isFullFormValid } from "../../util/Validators";
import { validateInput } from "./UserVerificationValidationService";


export const userVerificationFormValidationInitialState = {
    userIdError: false,
    verificationCodeError: false,
    emailError: false,
    
    userIdErrMsg: "",
    verificationCodeErrMsg: "",
    emailErrMsg: "",
    isFormValid: true
}


export const UserVerificationFormValidationReducer = (reactState, action) => {
    if (!action.payload) {
        return reactState;
    }
    let isValid = false;
    switch (action.type) {
        case "VALIDATE_USERID":
            let { userId } = action.payload;
            let userIdValidationState = validateInput('userId', userId);
            isValid = !userIdValidationState.hasError;
            let userIdErrMsg = userIdValidationState.error;
            return {
                ...reactState,
                ...({ userIdError: !isValid, userIdErrMsg: userIdErrMsg, isFormValid: isFullFormValid(reactState, 'userIdError', !isValid) })
            };
        case "VALIDATE_VERIFICATIONCODE":
            let { verificationCode } = action.payload;
            let verificationCodeValidationState = validateInput('verificationCode', verificationCode);
            isValid = !verificationCodeValidationState.hasError;
            let verificationCodeErrMsg = verificationCodeValidationState.error;
            
            return {
                ...reactState,
                ...({ verificationCodeError: !isValid, verificationCodeErrMsg: verificationCodeErrMsg, isFormValid: isFullFormValid(reactState, 'verificationCodeError', !isValid) })
            };
        case "VALIDATE_EMAIL":
            let { email } = action.payload;
            let emailValidationState = validateInput('email',email);
            isValid = !emailValidationState.hasError;
            let emailErrMsg = emailValidationState.error;
            return {
                ...reactState,
                ...({ emailError: !isValid, emailErrMsg: emailErrMsg, isFormValid: isFullFormValid(reactState, 'emailError', !isValid) })
            };

        default:
            return reactState
    }
}



